// First-touch acquisition capture for signup attribution.
//
// On the first page load that carries a usable signal (utm_* params or an
// external referrer), we persist it to localStorage. Later visits keep the
// original value (first-touch wins). authStore.register reads it and sends it
// to the backend, where it is stored on the user row and surfaced in /gestion/users.

const STORAGE_KEY = 'mq_acq';

function isExternalReferrer(ref) {
    if (!ref) return false;
    try {
        return new URL(ref).origin !== window.location.origin;
    } catch {
        return false;
    }
}

// Run once at app startup (main.jsx), before React mounts, so we read the real
// entry URL + document.referrer of the initial full page load.
export function captureAcquisitionFirstTouch() {
    try {
        if (localStorage.getItem(STORAGE_KEY)) return; // first-touch already captured

        const params = new URLSearchParams(window.location.search);
        const utm_source = (params.get('utm_source') || '').slice(0, 100);
        const utm_medium = (params.get('utm_medium') || '').slice(0, 100);
        const utm_campaign = (params.get('utm_campaign') || '').slice(0, 150);
        const referrer = isExternalReferrer(document.referrer) ? document.referrer.slice(0, 512) : '';
        const landing_page = (window.location.pathname + window.location.search).slice(0, 255);

        // Only persist if there is an actual acquisition signal worth attributing.
        if (utm_source || utm_medium || utm_campaign || referrer) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({
                utm_source, utm_medium, utm_campaign, referrer, landing_page,
            }));
        }
    } catch {
        // localStorage / URL parsing unavailable — acquisition is best-effort, skip silently.
    }
}

export function getAcquisition() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

// Parrainage (migration 178) : code ?ref= du lien partagé par un parrain. Indépendant
// de la provenance ci-dessus (qui ne s'écrit qu'une fois) : le premier code vu est gardé.
const REF_KEY = 'mq_ref';

export function captureReferral() {
    try {
        const ref = (new URLSearchParams(window.location.search).get('ref') || '').trim();
        if (ref && /^[A-Za-z0-9-]{4,16}$/.test(ref) && !localStorage.getItem(REF_KEY)) {
            localStorage.setItem(REF_KEY, ref.toUpperCase());
        }
    } catch {
        // best effort
    }
}

export function getReferralCode() {
    try {
        return localStorage.getItem(REF_KEY) || null;
    } catch {
        return null;
    }
}
